export const ru = {
    'id-predictor': 'ID прогноза: {id}'
};
